export class CompanyBudgetRolloverPayload {
  constructor(rolloverData = {}) {
    this.rollover_enabled = rolloverData.rolloverEnabled || false;
    this.company_id = rolloverData.companyId || "";
    this.rollover_duration = rolloverData.rolloverDuration || "";
  }
}

export default CompanyBudgetRolloverPayload;
